import Cookies from 'universal-cookie';
import ApiClient from './apiClient.js';

class User {
  constructor() {
    this.username = null;
    this.apiClient = new ApiClient();

    this.token = this.loadToken();
    this.username = this.loadUsername();
    if (this.token) this.isAuthenticated = true;
    else this.isAuthenticated = false;
  }
  
  isAuthenticated() {
    return this.isAuthenticated;
  }
  
  saveUsername(username) {
    var cookies = new Cookies();
    cookies.set('username', username, { path: '/'});
  }
  
  saveToken(token) {
    var cookies = new Cookies();
    cookies.set('token', token, { path: '/'});
  }
  
  deleteToken() {
    var cookies = new Cookies();
    cookies.remove('token', { path: '/'});
  }
  
  loadToken() {
    var cookies = new Cookies();
    var token = cookies.get('token');
    return token;
  }
  
  loadUsername() {
    var cookies = new Cookies();
    var username = cookies.get('username');
    return username;
  }
  
  deleteUsername() {
    var cookies = new Cookies();
    cookies.remove('username', { path: '/'});
  }
  
  authenticate(callback, errorCallback, username, password) {
    this.apiClient.login(username, password)
      .then( response => { 
        if (response.success) {
          this.isAuthenticated = true;
          this.token = response.token;
          this.username = username;
          this.saveUsername(this.username);
          this.saveToken(this.token);
          callback();
        } else {
          errorCallback(response.message);
        }
      })
      .catch( err => { 
        errorCallback(err);
      });
  }

  signOut(callback) {
    this.isAuthenticated = false;
    this.token = null;
    this.deleteToken();
    this.deleteUsername();
    if (callback) callback();
  }
  
}
  
export default User